module.exports = __webpack_public_path__ + "img/6.a51f2b88.jpg";